import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Screen.module.css';
import { DBCheckBox } from '_components';


class PatientCareCenterNoteSubjectiveScreen extends React.Component {

	handleNoneClick(selected) {
		if (selected) {
			let fields = ['EVSUBSCREENDIPLOPIA',
				'EVSUBSCREENDYSPHAGIA',
				'EVSUBSCREENDYSARTHRIA',
				'EVSUBSCREENDROPATT',
				'EVSUBSCREENNIGHTPAIN',
				'EVSUBSCREENTINNITUS',
				'EVSUBSCREENATAXIA',
				'EVSUBSCREENNAUSEA',
				'EVSUBSCREENNUMBNESS',
				'EVSUBSCREENNYSTAGMUS',
				'EVSUBSCREENSWALLOW',
				'EVSUBSCREENWEIGHT',
				'EVSUBSCREENDIZZY'
			];
			this.props.clearFields(this.props.noteId, 'PTEVAL', 'EVNO', this.props.evno, fields);
		}
	}

	render() {
		return (
			<PatientCareCenterNoteSection id='subj_screen' name='Screening' level={1} className={styles.required}>
				<div className={styles.row}>
					<span className={styles.col1} />
					<DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBSCREENNONE' className={styles.col2} label='None'
						onClick={(selected) => this.handleNoneClick(selected)}
					/>
					{this.props.noneSelected === false &&
						<DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBSCREENATAXIA' className={styles.col3} label='Ataxia' />
					}
				</div>

				{this.props.noneSelected === false &&
					<div>
						<div className={styles.row}>
							<span className={styles.col1} />
							<DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBSCREENDIPLOPIA' className={styles.col2} label='Diplopia' />
							<DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBSCREENNAUSEA' className={styles.col3} label='Nausea' />
						</div>

						<div className={styles.row}>
							<span className={styles.col1} />
							<DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBSCREENDYSPHAGIA' className={styles.col2} label='Dysphagia' />
							<DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBSCREENNUMBNESS' className={styles.col3} label='Numbness' />
						</div>

						<div className={styles.row}>
							<span className={styles.col1} />
							<DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBSCREENDYSARTHRIA' className={styles.col2} label='Dysarthria' />
							<DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBSCREENNYSTAGMUS' className={styles.col3} label='Nystagmus' />
						</div>

						<div className={styles.row}>
							<span className={styles.col1} />
							<DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBSCREENDROPATT' className={styles.col2} label='Drop Attacks' />
							<DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBSCREENSWALLOW' className={styles.col3} label='Difficulty Swallowing' />
						</div>

						<div className={styles.row}>
							<span className={styles.col1} />
							<DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBSCREENNIGHTPAIN' className={styles.col2} label='Night Pain' />
							<DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBSCREENWEIGHT' className={styles.col3} label='Unexplained Weight Loss' />
						</div>

						<div className={styles.row}>
							<span className={styles.col1} />
							<DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBSCREENTINNITUS' className={styles.col2} label='Tinnitus' />
							<DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBSCREENDIZZY' className={styles.col3} label='Dizziness' />
						</div>
					</div>
				}
			</PatientCareCenterNoteSection>
		);
	}

}

function mapDispatchToProps(dispatch) {
	return {
		clearFields: bindActionCreators(noteActions.clearFields, dispatch)
	};
}

function mapStateToProps(state) {
	let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
	let evno = parseInt(noteId.split("_")[1]);

	return {
		noteId: noteId,
		evno: evno,
		noneSelected: state.entities.notes.PTEVAL[evno].EVSUBSCREENNONE ? state.entities.notes.PTEVAL[evno].EVSUBSCREENNONE : false,
	};
}

const connectedPatientCareCenterNoteSubjectiveScreen = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectiveScreen);
export { connectedPatientCareCenterNoteSubjectiveScreen as PatientCareCenterNoteSubjectiveScreen };

